import { useQuery } from '@tanstack/react-query'
import type { CourseDetail, CourseSummary, LessonDetail } from '@shared/types/catalog'
import { api } from './api'

export const catalogKeys = {
  courses: ['courses'] as const,
  course: (courseId: string) => ['courses', courseId] as const,
  lesson: (lessonId: string) => ['lessons', lessonId] as const,
}

export function useCourses() {
  return useQuery({
    queryKey: catalogKeys.courses,
    queryFn: () => api<{ courses: CourseSummary[] }>('/courses').then((r) => r.courses),
  })
}

export function useCourse(courseId: string | undefined) {
  return useQuery({
    queryKey: catalogKeys.course(courseId ?? ''),
    queryFn: () => api<{ course: CourseDetail }>(`/courses/${courseId!}`).then((r) => r.course),
    // The id arrives one request later than the page mounts.
    enabled: Boolean(courseId),
  })
}

export function useLesson(lessonId: string) {
  return useQuery({
    queryKey: catalogKeys.lesson(lessonId),
    queryFn: () => api<{ lesson: LessonDetail }>(`/lessons/${lessonId}`).then((r) => r.lesson),
    // Lesson content is static per release; caching it aggressively is what
    // makes a lesson resumable offline once it has been opened.
    staleTime: 30 * 60_000,
    gcTime: 24 * 60 * 60_000,
  })
}
